var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"octadesk-loader-connectando"},[_c('span',{staticClass:"octadesk-loader-text"},[_vm._v(_vm._s(_vm.$t(_vm.i18nKeyMessage)))]),_c('PulseLoader',{attrs:{"height":"","width":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }